import React from 'react';

export default function Hero({ t }) {
  const roleParts = t.hero.eyebrow.split(' | ');

  return (
    <section id="top" className="max-w-content mx-auto px-4 md:px-8 pt-8 md:pt-12 pb-6 md:pb-8">
      <div className="grid grid-cols-1 md:grid-cols-[1.25fr_1fr] gap-8 md:gap-14 items-start">

        {/* Left column */}
        <div>
          <h1
            className="font-display font-medium tracking-tightest text-ink leading-none m-0 mb-5"
            style={{ fontSize: 'clamp(40px, 6vw, 76px)', lineHeight: 1.0 }}
          >
            {t.hero.greeting}
          </h1>

          <p
            className="font-body font-normal text-ink-2 m-0 mb-3"
            style={{ fontSize: 'clamp(20px, 2vw, 26px)', lineHeight: 1.3 }}
          >
            {t.hero.tagline}
          </p>

          <p
            className="font-body font-normal text-ink-2 m-0 mb-8"
            style={{ fontSize: 'clamp(20px, 2vw, 26px)', lineHeight: 1.3 }}
          >
            {t.hero.body}
          </p>

          {/* Portrait — mobile only */}
          <div className="block md:hidden mb-8">
            <div
              className="relative overflow-hidden bg-bg-soft w-full"
              style={{ aspectRatio: '400 / 460', borderRadius: 18 }}
            >
              <img
                src="/assets/portrait.png"
                alt="Javier Bonilla"
                style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', display: 'block' }}
              />
            </div>
            <div className="font-body text-ink-2 text-center mt-3" style={{ fontSize: 16, lineHeight: 1.5 }}>
              <span className="font-semibold text-ink">{roleParts[0]}</span>
              <span className="text-ink-3 mx-1.5">·</span>
              <span>{roleParts[1]}</span>
            </div>
          </div>

          {/* Domains row */}
          <div className="flex items-baseline gap-1.5 flex-wrap pt-[18px] mb-6">
            <div className="font-mono text-[12px] tracking-[0.1em] uppercase text-ink-3 shrink-0">
              {t.domains.label}
            </div>
            <div className="text-[15px] text-ink-2 leading-relaxed">
              {t.domains.items.map((d, i) => (
                <React.Fragment key={i}>
                  <span className="text-ink">{d}</span>
                  {i < t.domains.items.length - 1 && (
                    <span className="text-ink-3 mx-2">·</span>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* Metrics row */}
          <div
            className="grid gap-5 md:gap-7 pt-6 md:pt-7"
            style={{ gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}
          >
            {t.stats.map((s, i) => (
              <div key={i}>
                <div
                  className="font-display font-medium text-ink mb-1.5"
                  style={{ fontSize: 'clamp(28px, 4vw, 38px)', lineHeight: 1, letterSpacing: '-0.03em' }}
                >
                  {s.value}
                </div>
                <div className="text-[13px] text-ink-2 leading-snug">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right column — portrait (desktop only) */}
        <div className="hidden md:flex flex-col gap-[18px] items-center md:items-end">
          <div
            className="relative overflow-hidden bg-bg-soft w-full md:w-[400px]"
            style={{ maxWidth: 400, aspectRatio: '400 / 460', borderRadius: 18 }}
          >
            <img
              src="/assets/portrait.png"
              alt="Javier Bonilla"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center top',
                display: 'block',
              }}
            />
          </div>

          {/* Role caption — one line, centered under photo */}
          <div
            className="font-body text-ink-2 w-full md:w-[400px] text-center"
            style={{ fontSize: 16, lineHeight: 1.5 }}
          >
            <span className="font-semibold text-ink">{roleParts[0]}</span>
            <span className="text-ink-3 mx-1.5">·</span>
            <span>{roleParts[1]}</span>
          </div>
        </div>

      </div>
    </section>
  );
}
